export const defaultToastOptions = {
  position: 'top' as const,
  isClosable: true,
  duration: 5000,
} as const;
